
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../store/httpClient";
import { TokenResponseDto } from "@/dtos/tokenResponseDto";

@Component
export default class CadDialogComponent extends Vue {
	@Prop()
	private openDialog!: boolean;
	@Prop()
	private articleId!: string;
	@Prop()
	private readonly!: boolean;
	private cadDialog: boolean = false;
	private articleHasUnsavedChanges: boolean = false;
	private currentWindowHeight: string = "100px";
	private articleToken: TokenResponseDto | null = null;
	private cadViewTick: number = 0;

	//private token: string = 'B3D70156-1053-4E42-88C6-E3EEBDD970B4';

	private mounted() {
		this.setWindowHeight();
	}
	private beforeMount() {
		window.addEventListener("resize", this.setWindowHeight);
	}
	private beforeDestroy() {
		window.removeEventListener("resize", this.setWindowHeight);
	}

	@Watch("openDialog")
	private async openCadDialog() {
		if (!this.cadDialog && this.openDialog === true) {
			try {
				const response = await httpClient().post(
					`article/GetArticleToken?articleId=${this.articleId}&isWritable=${!this.readonly}`
				);
				this.articleToken = response.data;
				if (this.articleToken != null) {
					// One fresh tick per opening. See articleCadViewUrl for why it must not be
					// generated inside the getter.
					this.cadViewTick = Date.now();
					window.addEventListener("message", this.handleArticleChangedInCad);
					this.cadDialog = true;
				}
			} catch (err) {
				console.log(`Für den Artikel konnte kein Token geladen werden. Error: ${err}`);
			}
		}
	}

	private handleArticleChangedInCad(event: any) {
		if (
			event.origin == "https://cad.test.blexon.com" ||
			event.origin == "https://cam.test.blexon.com" ||
			event.origin == "https://cad.blexon.com" ||
			event.origin == "https://cam.blexon.com" ||
			event.origin == "http://localhost:8180" ||
			event.origin == "http://localhost:8185"
		) {
			if (event.data == `article-${this.articleId}-closed`) {
				this.closeCadDialog(true);
			} else if (event.data == `article-${this.articleId}-saved`) {
				this.closeCadDialog(false);
			}
		}
	}

	private async closeCadDialog(deleteToken: boolean) {
		window.removeEventListener("message", this.handleArticleChangedInCad);
		// delete token only when the article was not saved.
		// Wenn der Artikel gespeichert wurde, wird das Token nach der Validierung gelöscht.
		if (deleteToken) {
			await httpClient().post(
				`article/DeleteToken?token=${this.articleToken ? this.articleToken.token : null}`
			);
		}
		this.cadDialog = false;
		this.articleToken = null;
		this.$emit("close");
	}

	private get articleCadViewUrl() {
		let localToken = "";
		if (this.articleToken !== null) {
			localToken = this.articleToken.token;
		}
		// The cache buster has to sit BEFORE the "#": everything after it is a URL fragment, which
		// the browser neither sends to the server nor uses as part of its cache key. Without it the
		// browser keeps serving a stale index.html from its cache, together with the stale (hashed)
		// asset references.
		// The language stays behind the hash, where the cam client reads it from the route query.
		// The helpdesk itself is German only, so it passes the cam client's default explicitly
		// instead of relying on its silent fallback.
		//
		// The tick is taken once per dialog opening (see openCadDialog) and must NOT be generated
		// here: this getter is re-evaluated whenever one of its reactive dependencies changes, and
		// a new tick before the "#" reloads the whole iframe instead of just changing its fragment.
		// Every such reload fires the viewer's beforeunload handler, whose Close deletes the cam
		// working directory of the token.
		const [origin, route = "/"] = String(process.env.VUE_APP_CAM_CLIENT_URL).split("#");
		return (
			`${origin}?tick=${this.cadViewTick}#${route}` +
			`${this.articleId}/${localToken}` +
			`?language=de-CH`
		);
	}

	private setWindowHeight() {
		// 165 besteht aus...
		// - Margins der Dialogbox (variieren etwas je nach Aspect Ratio)
		// - Buttons für Speichern / Schliessen im Dialogfenster
		// - Sicherheitsmarge, sodass sicher keine Scrollbar im Dialog erscheint
		const currentHeight = window.innerHeight - 65;
		this.currentWindowHeight = `${currentHeight}px`;
	}
}
